import React, { Fragment, Component } from 'react';
import { connect } from 'react-redux';
import setToken from 'modules/authentication/actions/setToken';

// const SetupToken = ({ children }) => <Fragment>{children}</Fragment>;

class SetupToken extends Component {
  componentDidMount() {
    const { token, dispatch } = this.props;

    dispatch(setToken(token));
  }

  render() {
    const { children } = this.props;

    return <Fragment>{children}</Fragment>;
  }
}

const mapState = state => ({
  token: state.session.access_token,
});

export default connect(mapState)(SetupToken);
